const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const SmallImage = require('module/profile_view/templates/small_image')
const Name = require('module/profile_view/components/name')
const Spotlight = require('module/profile_view/components/spotlight')
const getLayoutColor = require('module/user/helpers/get_layout_color')
const getLuminance = require('lib/get_luminance')


function PortfolioHeader({ user, hidden, close }, { router }) {
    const fixed = ! hidden
    const className = classNames({ fixed })
    const close_href = router.location.pathname.replace(/\/portfolio\/?/, '')
    const color = getLayoutColor(user)
    const luminance = getLuminance(color)
    const image_size = 30

    function onClickClose(e) {
        e.preventDefault()
        close()
    }

    return (
        <header className={className}>
            <div className="structure">
                <section className="image-name">
                    <SmallImage user={user} width={image_size} height={image_size} />
                    <Name user={user} />
                </section>
                <Spotlight user={user} color={color} luminance={luminance} />
            </div>
            <a href={close_href} onClick={onClickClose} className="close glyph-center glyph-close"></a>
        </header>
    )
}
PortfolioHeader.propTypes = {
    user: PropTypes.object.isRequired,
    hidden: PropTypes.bool,
    close: PropTypes.func.isRequired,
}
PortfolioHeader.contextTypes = {
    router: PropTypes.object,
}

module.exports = PortfolioHeader
